import { AdminService } from './../services/admin.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { AppConstant } from '../config/app.constant';
import { AppStateProvider } from '../providers/app-state.provider';
import { CommonService } from '../services/common.service';

@Component({
  standalone: false,
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
  meetingNav;
  overviewData: any;
  constructor(private adalService: MsAdalAngular6Service, private commonService: CommonService, private route: Router, private appStateSrv: AppStateProvider, private adminSrv: AdminService) { }

  ngOnInit(): void {
    this.adminSrv.getSavedAdminDetails().subscribe(details => {
      if (details !== null)
        this.adminSrv.getTenantOverview().subscribe(response => {
          if (response)
            this.overviewData = {
              creditPointsAllocated: response.creditPointsAllocated,
              creditPointsUsed: response.creditPointsUsed,
              creditPointsValidityInDays: response.creditPointsValidityInDays,
              employeeCheckInForDay: response.employeeCheckInForDay,
              employeeEnrolled: response.employeeEnrolled,
              employeeRegisteredForMonth: response.employeeRegisteredForMonth,
              meetingsBookedForDay: response.meetingsBookedForDay,
              meetingsBookedForDayDuration: response.meetingsBookedForDayDuration,
              purchasePointsAllocated: response.purchasePointsAllocated,
              purchasePointsUsed: response.purchasePointsUsed
            }

        })
    })

    this.meetingNav = [
      {
        index: "0",
        name: "Overview",
        link: '/overview'
      }
    ];

    const route = {
      index: "0",
      name: "Overview",
      link: '/overview'
    };
    this.appStateSrv.setSideNavState(route);


    if (localStorage.getItem(AppConstant.localStorage.IsCLLogin) == "1") {
      if (this.adalService.isAuthenticated == true) {
        this.getAdmin();
      }
      else {
        this.route.navigateByUrl("");
      }
    }
  }

  getAdmin() {
    this.commonService.getAdminToken(this.adalService.LoggedInUserEmail).subscribe(r => {
      if (r.isValid == false) {
        this.route.navigateByUrl("");
      }
    });
  }

  navigateToReportsWithFilter(e) {
    e.preventDefault();
    const queryParams = {
      type:1,
      fromDate: (new Date().getMonth() + 1) + "/" + new Date().getDate() + "/" + new Date().getFullYear(),
      toDate: (new Date().getMonth() + 1) + "/" + new Date().getDate() + "/" + new Date().getFullYear(),
      select: "All"
    }
    localStorage.setItem('reportQuery', JSON.stringify(queryParams))
    this.route.navigate(['/reports'])
  }
}
